import {ANIMAL_REGISTRY} from './animal-registry.js';
import {toWildlifeManifest} from './animal-registry-three.js';
// Exact selected exports and legacy rig bindings from the reviewed registry.
export const WILDLIFE_ASSETS=toWildlifeManifest(ANIMAL_REGISTRY);
